module.exports = __webpack_public_path__ + "img/pufeite.778f7879.png";